import React, { Component, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Api, { ILoginUserRequest, useApi } from '../api/Api';
import NavigateHelper from '../api/NavigateHelper';

const LoginUserPage = () => {
    const [api, setApi] = useState<Api>();

    useApi(async (theApi) => {
        setApi(theApi);
    });

    const [args, setArgs] = useState<ILoginUserRequest>({
        email: "",
        password: "",
        rememberMe: false
    });

    var navigate = useNavigate();

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setArgs({
            ...args,
            [name]: value,
        });
    };

    const handleCheckChange = (e: any) => {
        const { name, checked } = e.target;
        setArgs({
            ...args,
            [name]: checked
        });
    }

    const login = async () => {
        var response = await api!.loginUserAsync(args);
        if (!(response!.hasErrors))
            new NavigateHelper(navigate).goHome();
    }

    if (api != null) {
        return (
            <div className="row">
                <div className="col-md-4">
                </div>
                <div className="col-md-4">

                    <div className="text-center">
                        <h1>Instructor Login</h1>
                    </div>

                    <div className="form-group mt-3">
                        <label>Email</label>
                        <input type="text" className="form-control" name="email" value={args.email} onChange={handleChange} />
                    </div>

                    <div className="form-group mt-3">
                        <label>Password</label>
                        <input type="password" className="form-control" name="password" value={args.password} onChange={handleChange} />
                    </div>

                    <div className="form-group mt-3">
                        <input type="checkbox" checked={args.rememberMe} name="rememberMe" onChange={handleCheckChange} /> Remember Me
                    </div>

                    <div className="form-group mt-3">
                        <button className="btn btn-sm btn-primary" onClick={() => login()}>Login</button>
                    </div>


                    <div className="form-group mt-3 text-center">
                        <Link to="/login">Operator Login</Link>
                    </div>

                </div>
                <div className="col-md-4">
                </div>
            </div>
        );
    } else {
        return (
            <div>...</div>
        );
    }
}

export default LoginUserPage;